export * from './login-logo.component';



// WEBPACK FOOTER //
// ./src/app/login/login-logo/index.ts